import { render, staticRenderFns } from "./EntradaItensListModal.vue?vue&type=template&id=2e9a8fd2&scoped=true"
import script from "./EntradaItensListModal.vue?vue&type=script&lang=js"
export * from "./EntradaItensListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a8fd2",
  null
  
)

export default component.exports